import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "legal-contracts"
    }}>{`Legal Contracts`}</h2>
    <h3 {...{
      "id": "overview"
    }}>{`Overview`}</h3>
    <p>{`Most organizations today have a variety of legal contracts that need to be created, edited, approved, and signed on a regular basis. In addition, many of these contracts require customization and branding to be applied. And no matter what, accurate document generation is crucial. The challenge is to automate what is now a manual process of including custom data elements to templates.`}</p>
    <p>{`Adobe Acrobat Services will let organizations:`}</p>
    <ul>
      <li parentName="ul">{`Create templates with dynamic fields that can be automatically merged with data`}</li>
      <li parentName="ul">{`Customize inputs and logic, for example adding clauses that only apply to specific geographies`}</li>
      <li parentName="ul">{`Build a workflow that allows for review, approval, and electronic signatures`}</li>
    </ul>
    <h3 {...{
      "id": "relevant-apis"
    }}>{`Relevant APIs`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/doc-generation.md"
        }}>{`Adobe Document Generation API`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/pdf-embed.md"
        }}>{`Adobe PDF Embed API`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.adobe.io/apis/documentcloud/sign.html"
        }}>{`Adobe Acrobat Sign API`}</a></li>
    </ul>
    <h3 {...{
      "id": "scenario"
    }}>{`Scenario`}</h3>
    <p>{`A technology company is drafting a legal contract. To do so, it needs inputs from agents, legal resources, and business managers. The contract requires company branding and to include some standard legal copy. Data from various sources, such as the correct terms, conditions, and clauses, must also be added. Once all of the content is collected, the final contract needs to be shared for feedback and final approval. When finished, it will be sent to customers for digital signatures.`}</p>
    <h3 {...{
      "id": "building-this-solution"
    }}>{`Building this Solution`}</h3>
    <ol>
      <li parentName="ol">{`Create a basic data model in JSON that helps determine document generation, such as customer profile information from a CRM`}</li>
      <li parentName="ol">{`Design contract templates in Microsoft Word`}</li>
      <li parentName="ol">{`Set conditional sections in the contract template, repeating elements, as well as place fields for Adobe Acrobat Sign`}</li>
      <li parentName="ol">{`Send both the Word template and JSON data input file to Adobe Document Generation API and receive a PDF file`}</li>
      <li parentName="ol">{`Embed the PDF file in the application for review and approval with Adobe PDF Embed API`}</li>
      <li parentName="ol">{`Once approved, send the agreement out for signature using Adobe Acrobat Sign API`}</li>
    </ol>
    <h3 {...{
      "id": "building-in-power-automate"
    }}>{`Building in Power Automate`}</h3>
    <p>{`A solution to this use-case can also be implemented in Power Automate by using the following Adobe connectors:`}</p>
    <ul>
      <li parentName="ul">{`Adobe PDF Services Connector (includes Document Generation)`}</li>
      <li parentName="ul">{`Adobe Acrobat Sign Connector`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      